<div class="row gx-5">
  <div class="col-12 col-sm-6">
    <p>
      This licence governs your access to and use of EuroGlobalMap, EuroRegionalMap, EuroDEM, Open Gazetteer, Open
      Cadastral Map and the High-value large-scale pan European prototype made available at
      <a href="https://www.mapsforeurope.org/licence" target="_blank">https://www.mapsforeurope.org/licence</a>. by
      EuroGeographics. EuroGeographics AISBL is an international non-profit association under
      Belgian law, with registered offices at Rue du nord / Noordstraat 76, 1000 Brussels, Belgium.
    </p>
    <p>
      The Dataset (as defined below) is protected by copyright and other applicable laws. The
      Dataset is provided under the terms of this licence, which you accept by using the Dataset and
      accepting the terms of the licence.
    </p>
    <h2 class="h3">Definitions</h2>
    <p>In this licence, the terms below have the following meanings:</p>
    <ul>
      <li>
        The “Dataset” means the EuroGlobalMap, EuroRegionalMap, EuroDEM, Open Gazetteer, Open Cadastral
        Map and the High-value large-scale pan European prototype, and the associated data, protected by
        international copyright and/or the database producer’s right.
      </li>
      <li>
        ‘Licensor’ means EuroGeographics and/or and its members, who jointly own the intellectual
        property rights on the Dataset.
      </li>
      <li>
        ‘Use of the Dataset’ means any act for any legal purpose, including commercial exploitation
        restricted by copyright or database rights, which includes:
        <ul>
          <li>
            Reproduction: to make a tangible copy of the Dataset or of an Adaptation by any means
            and in any form, on any support;
          </li>
          <li>
            Communication to the public: to spread the Dataset or an Adaptation to the public in an
            intangible form, by any means, in a linear way or on the individual demand of the
            end-user;
          </li>
          <li>
            Distribution: to spread tangible copies of the Dataset or of the Adaptation among the
            public;
          </li>
          <li>
            Adaptation: to alter, arrange, derive or modify the Dataset, for example, by combining
            it with other creations, information or works, or by including it in your own product or
            application.
          </li>
          <li>
            Extraction: to transfer all or a substantial part of the Dataset or an Adaptation to
            another medium by any means or in any form, in a permanent or temporary way;
          </li>
          <li>
            Reutilisation: to make available to the public all or a substantial part of the Dataset
            or an Adaptation by the distribution of copies, by renting, by on-line or other forms of
            transmission.
          </li>
        </ul>
      </li>
      <li>
        ‘You’ means the natural or legal person, or body of persons, corporate or incorporate,
        acquiring rights under this licence.
      </li>
    </ul>
    <p>
      Where these “Uses” are defined by law and such legal definitions are more favourable to
      Licensor, the legal definition will apply.
    </p>
    <h2 class="h3">Use of the Dataset under this licence</h2>
    <p>Use of the Dataset indicates Your acceptance of the terms and conditions below.</p>
    <p>
      The Licensor grants You a worldwide, royalty-free, perpetual, non-exclusive licence to
      exercise the rights (reproduction, communication to the public, adaptation, distribution,
      extraction and reutilisation) in the Dataset, subject to the conditions and restrictions
      below.
    </p>
  </div>
  <div class="col-12 col-sm-6">
    <h2 class="h3">Restrictions</h2>
    <ul>
      <li>
        <p>
          You may use the Datasets as described above, on condition that You acknowledge the
          intellectual rights and the source of the Dataset, by including the following attribution
          statement within every use of the Dataset:
        </p>

        <p class="font-italic">
          "This dataset includes Intellectual Property from European National Mapping and Cadastral
          Authorities and is licensed on behalf of these by EuroGeographics. Original dataset is
          available for free at https://www.mapsforeurope.org. Terms of the licence available at
          <a href="https://www.mapsforeurope.org/licence" target="_blank">https://www.mapsforeurope.org/licence</a>
          All attribution statements can be found
          <a href="https://www.mapsforeurope.org/attributions" target="_blank">here</a>."
        </p>

        <p>
          In case the long statement above cannot be used, you may use the following short form:
        </p>
        <p class="font-italic">"&copy; EuroGeographics {{ year }}."</p>

        <p>
          All attribution statements
          <a routerLink="/attributions" target="_blank">can be found here.</a>
        </p>
      </li>
      <li>
        <p>
          You must include the same acknowledgement requirement in any sub-licences that you grant,
          and a requirement that any further sub-licences do the same. In the sub-licences you and
          the sub-licensee may not impose any additional and different conditions, or apply any
          measures that restrict the exercise of the rights granted under this license.
        </p>
      </li>
      <li>
        This licence does not grant any further rights to use the trademark “EuroGeographics”.
      </li>
      <li>
        You must ensure that you will not use the Dataset in a way that suggests any official status
        or that the Licensor endorses You or Your use of the Dataset; You must ensure that You do
        not mislead others or misrepresent the Dataset or its source.
      </li>
      <li>
        Although You are entitled to create Adaptations of the Dataset, You may not mutilate or
        distort the Dataset in a way that is prejudicial to the honour and the reputation of the
        Licensor or any of the authors. This includes that the Dataset should not be altered in such
        a way that the information contained therein becomes erroneous, misleading, scientifically
        incorrect and illegal.
      </li>
    </ul>
    <p>
      Failure to comply with this licence will automatically put an end to this licence, without
      notice to You and without prior judiciary order. Licensor reserves the right to claim
      compensation for its entire damage suffered due to Your breach of the licence.
    </p>
    <p>
      Licensor reserves the right to discontinue the availability of the Dataset under the current
      terms. Any continued use will be at your own risk.
    </p>
    <h2 class="h3">No warranty</h2>
    <p>
      The Dataset is licensed ‘as is’ and Licensor excludes all representations, warranties,
      obligations and liabilities in relation to the Dataset and for all uses of the Dataset like
      the reproduction, the adaptation, the extraction, the distribution, the communication and the
      reutilisation to the maximum extent permitted by law. Licensor does not offer any guarantee
      concerning the completeness, the absence of errors, non-infringement or the fitness to any
      purpose.
    </p>

    <p>
      You alone are responsible for the content You use and publish, including for the content
      conveyed by the Dataset.
    </p>
    <p>
      The Licensor is not liable for any errors or omissions in the Dataset or Adaptation and shall
      not be liable for any loss, costs, compensation, injury or damage of any kind caused by or due
      to its use.
    </p>
    <h2 class="h3">Personal Data</h2>
    <p>
      To the extent we collect personal data in the sense of applicable law, the Licensor will only
      do so in conformity with Belgian law and take all necessary measures to ensure that such
      personal data are not made available to third parties without prior consent of the person
      concerned. You agree to protect and process the personal data conform the applicable
      regulation and cooperate with the Licensor where reasonably necessary.
    </p>
    <h2 class="h3">Applicable Law</h2>
    <p>
      This licence is exclusively governed by the laws of Belgium. The courts of Brussels, Belgium,
      alone are competent to decide any litigation arising from the application of this licence.
    </p>
  </div>
</div>
